import setGrabCursor from './setGrabCursor.js';
import unsetGrabCursor from './unsetGrabCursor.js';
export default {
  setGrabCursor,
  unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/grab-cursor/index.js
// module id = 1155
// module chunks = 9